import { Typography } from '@pocketlaw/tetris';
export function ActivityEntryText(props) {
    const { children } = props;
    return (<Typography $appearance="300" $fontSize="medium" $lineHeight="neutralized">
      {children}
    </Typography>);
}
